// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Size } from 'models/propTypes/tile';

import Selectable from 'components/focus/Selectable';

import styles from './MediaTile.module.scss';
import MediaView from './MediaView';

const MediaTile = ({
  className,
  size,
  isNowPlaying,
  focusId,
  onClick,
  onFocusSet,
  ttsText,
  renderMetadata,
  renderTitle,
  autoSizeSrc,
  isDvr,
  ...rest
}) => {
  return (
    <Selectable
      onSelect={onClick}
      focusId={focusId}
      className={className}
      onFocusSet={onFocusSet}
      data-testid="media-tile"
      ttsText={ttsText}
      render={({ hasFocus }) => (
        <div
          className={classNames(
            'd-flex',
            'flex-column',
            styles[`${size}_w`],
            hasFocus ? styles.focused : styles.unfocused,
          )}
        >
          <button
            type="button"
            onClick={onClick}
            // Safari hides the outline if the style is applied to the internal div
            className={classNames('d-flex', 'flex-column', styles.button)}
          >
            <MediaView
              renderMetadata={renderMetadata}
              size={size}
              isNowPlaying={isNowPlaying}
              hasFocus={hasFocus}
              autoSizeSrc={autoSizeSrc}
              className={styles.hoverBorder}
              isDvr={isDvr}
              {...rest}
            />
          </button>
          {renderTitle && (
            <div
              className={classNames(
                'w-100',
                'text-white',
                'text-left',
                'mt-3',
                styles.title,
                {
                  [styles.titleFocused]: hasFocus,
                },
              )}
            >
              {renderTitle(hasFocus)}
            </div>
          )}
        </div>
      )}
    />
  );
};

MediaTile.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: Size.isRequired,
  isNowPlaying: PropTypes.bool,
  focusId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  onFocusSet: PropTypes.func,
  ttsText: PropTypes.string.isRequired,
  renderMetadata: PropTypes.func,
  renderTitle: PropTypes.func,
  autoSizeSrc: PropTypes.bool, // Tells the mediatile that it's receiving a configurable image source that it should size
  isDvr: PropTypes.bool,
};

MediaTile.defaultProps = {
  className: null,
  isNowPlaying: false,
  focusId: null,
  onClick: () => {},
  onFocusSet: () => {},
  renderMetadata: null,
  renderTitle: null,
  autoSizeSrc: true,
  isDvr: false,
};

export default MediaTile;
